import { Link } from 'react-router-dom';
import { StatCard, Card, ProgressBar } from '@getpay93/ui';
import { useDashboardSummary, useUpcoming, useOnboarding, useHealth } from '../../data/hooks';
import { money, shortDate } from '../../lib/format';

const STEPS: { key: 'planCreated' | 'clientAdded' | 'inviteSent' | 'firstPaymentRecorded'; label: string; to: string }[] = [
  { key: 'planCreated', label: 'Crea tu primer plan', to: '/app/clientes' },
  { key: 'clientAdded', label: 'Agrega un cliente', to: '/app/clientes' },
  { key: 'inviteSent', label: 'Envía una invitación', to: '/app/clientes/invitar' },
  { key: 'firstPaymentRecorded', label: 'Registra tu primer pago', to: '/app/cobros' },
];

export function Dashboard() {
  const summary = useDashboardSummary();
  const upcoming = useUpcoming();
  const onboarding = useOnboarding();
  const health = useHealth();
  const s = summary.data;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {onboarding.data && !onboarding.data.completed ? (
        <Card>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <strong style={{ color: 'var(--text-strong)' }}>Primeros pasos</strong>
            <span style={{ color: 'var(--text-hint)', fontSize: 13 }}>{onboarding.data.stepsCompleted}/{onboarding.data.totalSteps}</span>
          </div>
          <ProgressBar value={onboarding.data.stepsCompleted} max={onboarding.data.totalSteps} height={6} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 12 }}>
            {STEPS.map((st) => {
              const done = onboarding.data![st.key];
              return (
                <Link key={st.key} to={st.to} style={{ display: 'flex', alignItems: 'center', gap: 8, color: done ? 'var(--text-hint)' : 'var(--text-body)', textDecoration: done ? 'line-through' : 'none' }}>
                  <span style={{ width: 16, height: 16, borderRadius: 999, border: `2px solid ${done ? 'var(--brand-green)' : 'var(--border-strong)'}`, background: done ? 'var(--brand-green)' : 'transparent' }} />
                  {st.label}
                </Link>
              );
            })}
          </div>
        </Card>
      ) : null}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
        <StatCard label="Clientes activos" value={s ? String(s.activeClients) : '—'} tone="green" icon="users" />
        <StatCard label="Cobrado del mes" value={money(s?.monthlyRevenue)} tone="green" icon="banknote" />
        <StatCard label="Por cobrar" value={money(s?.pendingAmount)} tone="amber" icon="clock" />
        <StatCard label="Vencido" value={money(s?.overdueAmount)} tone="red" icon="alert-triangle" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}>
        <Card>
          <strong style={{ color: 'var(--text-strong)' }}>Próximos cobros</strong>
          <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            {(upcoming.data ?? []).slice(0, 6).map((u) => (
              <div key={u.invoiceId} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                <span style={{ color: 'var(--text-body)' }}>{u.clientName}</span>
                <span style={{ color: 'var(--text-muted)' }}>{money(u.amount)} · {shortDate(u.dueDate)}</span>
              </div>
            ))}
            {upcoming.data && upcoming.data.length === 0 ? <span style={{ color: 'var(--text-hint)' }}>Sin cobros próximos.</span> : null}
          </div>
        </Card>
        <Card>
          <strong style={{ color: 'var(--text-strong)' }}>Salud de cobro</strong>
          <div style={{ fontSize: 34, fontWeight: 800, color: 'var(--brand-green)', marginTop: 8 }}>{health.data ? `${health.data.score}` : '—'}</div>
          <div style={{ color: 'var(--text-muted)' }}>{health.data?.status}</div>
        </Card>
      </div>
    </div>
  );
}
